module.exports = __webpack_public_path__ + "img/0Q3A8493_L_BlackMatted_MockedUp.b364e043.jpg";